<template>
  <div class="k-card">
    <div v-if="hasBadgeSlot" class="badge"><slot name="badge"></slot></div>
    <b-overlay
      :show="loading"
      v-on:shown="onShown"
      rounded="lg"
      :opacity="1"
      :no-fade="noFade"
      variant="white"
    >
      <b-container>
        <b-row>
          <template v-if="left">
            <b-col class="pane center-both ptb32" cols="12" md="5" lg="4">
              <div>
                <slot name="pane"></slot>
              </div>
            </b-col>
            <b-col cols="12" md="7" lg="8" class="v-center p32">
              <div>
                <h2>
                  <slot name="title"></slot>
                </h2>
                <div class="desc">
                  <slot name="description"></slot>
                </div>
              </div>
            </b-col>
          </template>
          <template v-else>
            <b-col cols="12" md="7" lg="8" class="v-center p32">
              <div>
                <h2>
                  <slot name="title"></slot>
                </h2>
                <div class="desc">
                  <slot name="description"></slot>
                </div>
              </div>
            </b-col>
            <b-col class="pane center-both ptb32" cols="12" md="5" lg="4">
              <div>
                <slot name="pane"></slot>
              </div>
            </b-col>
          </template>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "SimpleCard",
  data() {
    return {
      noFade: true,
    };
  },
  props: {
    left: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasBadgeSlot() {
      return !!this.$slots["badge"];
    },
  },
  methods: {
    onShown: function () {
      this.noFade = false;
    },
  },
};
</script>

<style scoped>
.k-card {
  border: var(--default-border);
  border-radius: var(--default-border-radius);
}
.k-card:not(:first-child) {
  margin-top: 32px;
}
.k-card h2 {
  font-size: 20px;
  font-weight: 600;
}
.k-card .desc {
  font-size: 15px;
}
.k-card .pane {
  background-color: var(--panel-bg-color);
}
@media (max-width: 767px) {
  .k-card .pane:first-child {
    border-bottom: var(--default-border);
  }
  .k-card .pane:last-child {
    border-top: var(--default-border);
  }
}
@media (min-width: 768px) {
  .k-card .pane:first-child {
    border-right: var(--default-border);
  }
  .k-card .pane:last-child {
    border-left: var(--default-border);
  }
}
.p32 {
  padding: 32px;
}
.ptb32 {
  padding: 32px 0;
}
</style>